(() => {
 if (customElements.get('markdown-collection')) return;
 customElements.define('markdown-collection', class extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return; this.initialized = true;
   this.cards = [...this.querySelectorAll('[data-sale-card]')];
   this.grid = this.querySelector('.md-collection__grid');
   const fields = {department:'departments',category:'category', size:'sizes', colour:'colours'};
   for (const [kind, field] of Object.entries(fields)) {
    const box = this.querySelector(`[data-sale-options="${kind}"]`);
    const values = [...new Set(this.cards.flatMap(card => (card.dataset[field] || '').split('|').filter(Boolean)))].sort((a,b) => a.localeCompare(b,undefined,{numeric:true}));
    for (const value of values) {
     const label=document.createElement('label'), input=document.createElement('input');
     input.type='checkbox'; input.value=value; input.dataset.saleFilter=kind;
     label.append(input,document.createTextNode(value)); box.append(label);
    }
    if (!values.length) box.textContent='No options available';
   }
   this.addEventListener('change',()=>this.update());
   this.querySelector('[data-sale-clear]').addEventListener('click',()=>{this.querySelectorAll('[data-sale-filter]').forEach(e=>e.checked=false);this.querySelector('[data-sale-sort]').value='featured';this.update();});
   this.addEventListener('toggle',e=>{if(e.target.tagName==='DETAILS'&&e.target.open)this.querySelectorAll('details').forEach(d=>{if(d!==e.target)d.open=false;});},true);
   this.onOutsideClick = e => { if(!e.target.closest('details') || !this.contains(e.target)) this.querySelectorAll('details').forEach(d=>d.open=false); };
   document.addEventListener('click',this.onOutsideClick);
   this.addEventListener('keydown',e=>{if(e.key==='Escape')this.querySelectorAll('details[open]').forEach(d=>{d.open=false;d.querySelector('summary').focus();});});
   this.update();
  }
  disconnectedCallback(){document.removeEventListener('click',this.onOutsideClick);}
  update() {
   const selected={department:[],category:[],size:[],colour:[]};
   this.querySelectorAll('[data-sale-filter]:checked').forEach(e=>selected[e.dataset.saleFilter].push(e.value));
   const key={department:'departments',category:'category',size:'sizes',colour:'colours'};
   let visible=0;
   for(const card of this.cards){card.hidden=!Object.keys(selected).every(kind=>!selected[kind].length||selected[kind].some(v=>(card.dataset[key[kind]]||'').split('|').includes(v)));if(!card.hidden)visible++;}
   const sort=this.querySelector('[data-sale-sort]').value, ordered=[...this.cards];
   if(sort==='price-asc')ordered.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
   if(sort==='price-desc')ordered.sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));
   if(sort==='newest')ordered.sort((a,b)=>Number(b.dataset.date)-Number(a.dataset.date));
   if(sort==='title')ordered.sort((a,b)=>a.dataset.title.localeCompare(b.dataset.title));
   ordered.sort((a,b)=>(a.dataset.available==='false')-(b.dataset.available==='false'));
   ordered.forEach(c=>this.grid.append(c));
   this.querySelector('[data-sale-count]').textContent=`${visible} Results`;
   const active=this.querySelector('[data-sale-active]');active.replaceChildren();
   for(const [kind,values]of Object.entries(selected))for(const v of values){const b=document.createElement('button');b.type='button';b.className='md-collection__chip';b.textContent=`${v} ×`;b.setAttribute('aria-label',`Remove ${kind} filter ${v}`);b.addEventListener('click',()=>{this.querySelectorAll('[data-sale-filter]').forEach(e=>{if(e.dataset.saleFilter===kind&&e.value===v)e.checked=false;});this.update();});active.append(b);}
   this.querySelector('[data-sale-empty]').hidden=visible>0;
  }
 });
})();
